'use client';
import React from 'react';
import Icon from '@/components/ui/AppIcon';

const reasons = [
  {
    icon: 'StarIcon',
    title: 'Опыт 15+ лет',
    description: 'Более 350 успешно завершённых объектов в Беларуси',
  },
  {
    icon: 'CheckCircleIcon',
    title: '100% Гарантия',
    description: 'Полная гарантия качества на все выполненные работы',
  },
  {
    icon: 'UserGroupIcon',
    title: 'Профессиональная команда',
    description: 'Опытные специалисты, прошедшие обучение и сертификацию',
  },
  {
    icon: 'PhoneIcon',
    title: 'Всегда на связи',
    description: 'Оперативная поддержка и консультации на всех этапах работ',
  },
];

const faqs = [
  {
    question: 'Какие виды бетонных работ вы выполняете?',
    answer: 'Мы выполняем полный спектр бетонных работ: фундаменты, перекрытия, подпорные стенки. Каждый проект выполняется с гарантией качества.',
  },
  {
    question: 'Какой опыт у компании СлавСтрой?',
    answer: 'Компания работает на рынке более 15 лет и успешно завершила болеe 350 объектов в Беларуси. Все работы выполняются опытной командой профессионалов.',
  },
  {
    question: 'Предоставляете ли вы гарантию на работы?',
    answer: 'Да, мы предоставляем 100% гарантию качества на все выполненные бетонные работы. Это гарантирует надежность и долговечность вашего объекта.',
  },
  {
    question: 'Как рассчитать стоимость работ?',
    answer: 'Используйте наш калькулятор объема бетона на сайте для быстрой оценки. Для точной стоимости оставьте заявку, и наш менеджер свяжется с вами в течение 30 минут.',
  },
];

export default function WhySection() {
  const [expandedFaq, setExpandedFaq] = React.useState<number | null>(null);

  return (
    <section id="why" className="py-16 sm:py-20 px-4 sm:px-6 bg-card">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 text-foreground">
          Почему СлавСтрой
        </h2>
        <p className="text-base sm:text-lg text-muted-foreground mb-10 sm:mb-12 max-w-2xl">
          Мы выбираем качество и надежность на каждом этапе работы.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12 sm:mb-16">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="p-5 sm:p-6 rounded-xl border border-border bg-background hover:shadow-lg transition-shadow duration-300"
            >
              <Icon
                name={reason.icon as Parameters<typeof Icon>[0]['name']}
                size={32}
                className="text-primary mb-4"
              />
              <h3 className="text-lg sm:text-xl font-semibold mb-2 text-foreground">
                {reason.title}
              </h3>
              <p className="text-sm text-muted-foreground">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 sm:mt-20 pt-12 sm:pt-16 border-t border-border">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 text-foreground">
            Часто задаваемые вопросы
          </h3>
          <p className="text-base sm:text-lg text-muted-foreground mb-8 sm:mb-10 max-w-2xl">
            Ответы на популярные вопросы о наших услугах и процессе работы.
          </p>
          <div className="space-y-3 sm:space-y-4 max-w-3xl">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="border border-border rounded-lg overflow-hidden bg-background hover:border-primary/50 transition-colors"
              >
                <button
                  onClick={() => setExpandedFaq(expandedFaq === i ? null : i)}
                  className="w-full px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between hover:bg-muted/50 transition-colors"
                >
                  <h4 className="text-left font-semibold text-foreground text-sm sm:text-base pr-2">
                    {faq.question}
                  </h4>
                  <Icon
                    name={expandedFaq === i ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                    size={20}
                    className="text-primary shrink-0 ml-2"
                  />
                </button>
                {expandedFaq === i && (
                  <div className="px-4 sm:px-6 py-4 bg-muted/30 border-t border-border">
                    <p className="text-muted-foreground leading-relaxed text-sm">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}